/**
 * Data Loader Utility
 * Handles loading JSON data by importing it directly
 */

import membersData from '../data/members.json';

/**
 * Gets member data from imported JSON file
 * @returns {Promise<Array>} Array of member objects
 */
export const fetchMembers = async () => {
  try {
    // Return imported data wrapped in a Promise for backward compatibility
    return Promise.resolve(membersData);
  } catch (error) {
    console.error('Error loading members data:', error);
    throw error;
  }
};

/**
 * Generic data fetcher for public JSON files
 * @param {string} fileName - Name of the JSON file in public/data folder
 * @returns {Promise<any>} Parsed JSON data
 */
export const fetchPublicData = async (fileName) => {
  try {
    const response = await fetch(`${process.env.PUBLIC_URL}/data/${fileName}`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(`Error loading ${fileName}:`, error);
    throw error;
  }
};
